module.exports = __webpack_public_path__ + "media/images/emoticons/ship-9c81fc5584c3f444820266c1e1f9f0e5.gif";